module.exports = __webpack_public_path__ + "static/media/next-gen-AI.ca6d30e2.svg";